<div
  id="btnGroup"
  class="d-flex d-inline mt-2 mx-auto justify-content-center"
  [ngClass]="{'col-md-8': buttonCount >= 3,'col-md-4': buttonCount == 2, 'btn-group': buttonCount > 1}">
  <ng-content></ng-content>
</div>
